module.exports = Promise.resolve(module.bundle.root("fHQSM"))